import { render, staticRenderFns } from "./link-button.vue?vue&type=template&id=6f6a5953&"
import script from "./link-button.vue?vue&type=script&lang=js&"
export * from "./link-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports